(function (_, app) {

	var commafy = function (num) {
		return num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
	};

	app.convert = app.convert || {};

	app.convert.toMoney = function (value, currency, minValue) {
		var money = parseFloat(value);
		if (typeof money !== 'number' || isNaN(money) || (typeof minValue === 'number' && money <= minValue)) return '';
		switch (app.GlobalSettings.Country.ID) {
			case 'KR':
				money = commafy(money);
				break;
			case 'DK':
				money = money.toFixed(2).replace(/\./g, ',');
				break;
			default:
				money = money.toFixed(2);
		}
		return (currency || app.GlobalSettings.CurrencySign || '') + money;
	};

})(_, app);